@if (svc.error(); as err) {

<div class="overlay-backdrop" (click)="close()">
  <div class="overlay-panel" (click)="$event.stopPropagation()">

    <!-- Header -->
    <div class="overlay-header">
      <div class="overlay-header__left">
        <span class="overlay-header__status">{{ err.statusCode }}</span>
        <span class="overlay-header__name">{{ err.name }}</span>
        @if (err.source) {
          <span class="overlay-header__source">{{ err.source }}</span>
        }
      </div>
      <button class="overlay-header__close" (click)="close()" title="Sluiten (Esc)">&#x2715;</button>
    </div>

    <!-- Root cause — de diepste exception prominent bovenaan -->
    @if (chain().length > 1) {
      <div class="overlay-root-cause">
        <div class="overlay-root-cause__label">Root cause</div>
        <div class="overlay-root-cause__type">{{ chain()[chain().length - 1].exceptionType }}</div>
        <div class="overlay-root-cause__message">{{ chain()[chain().length - 1].message }}</div>
      </div>
    }

    <!-- Exception chain -->
    <div class="overlay-body">
      <div class="overlay-chain-label">Exception chain</div>

      @for (ex of chain(); track $index) {
        <div class="overlay-exception"
             [class.overlay-exception--root]="$index === 0"
             [class.overlay-exception--deepest]="$index === chain().length - 1 && chain().length > 1">

          <div class="overlay-exception__header">
            <span class="overlay-exception__index">[{{ $index }}]</span>
            <span class="overlay-exception__type">{{ ex.exceptionType }}</span>
            @if ($index === chain().length - 1 && chain().length > 1) {
              <span class="overlay-exception__tag">root cause</span>
            }
          </div>

          @if (ex.message) {
            <p class="overlay-exception__message">{{ ex.message }}</p>
          }

          @if (ex.stackTrace) {
            <pre class="overlay-exception__stack">{{ ex.stackTrace }}</pre>
          }

        </div>
      }
    </div>

  </div>
</div>

}
